import {
  Datagrid,
  DateField,
  List,
  RichTextField,
  TextField,
  useDataProvider,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";

import { Select, MenuItem, Chip } from "@mui/material";
import { useCallback } from "react";

export function ContestList(props) {
  return (
    <List {...props}>
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="name" />
        {/* <RichTextField source="description" /> */}
        <DateField source="startDate" showTime />
        <DateField source="endDate" showTime />
        <TextField source="type" />
        <ChangeStatus source="contestStatus" />

        <TextField source="organizerName" />
        <TextField source="organizerEmail" type="email" />
        <TextField source="organizerPhone" />
      </Datagrid>
    </List>
  );
}

function ChangeStatus(props) {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const provider = useDataProvider();

  const updateStatus = useCallback(async (status) => {
    provider
      .update("contest", {
        id: record.id,
        data: {
          contestStatus: status,
          id: record.id,
        },
      })
      .then(({ data }) => {
        if (data?.id) {
          refresh();
          notify(`Contest status changed to ${status}`, { type: "info" });
        } else {
          notify("Error Updating Contest", { type: "error" });
        }
      })
      .catch((err) => {
        console.log(err);
        notify("Something went wrong", { type: "error" });
      });
  });
  return (
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      defaultValue={record?.contestStatus}
      label="contestStatus"
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        updateStatus(e.target.value);
      }}
      sx={{ width: "150px" }}
    >
      <MenuItem value="draft">
        <Chip label="Draft" color="warning" />
      </MenuItem>
      <MenuItem value="active">
        <Chip label="Active" color="success" />
      </MenuItem>
      <MenuItem value="ended">
        <Chip label="Ended" color="default" />
      </MenuItem>
    </Select>
  );
}
